(ns pfo.link.core (:require [pfo.util :refer [split-string] :rename {split-string split} ]))

(defn parent-info [query-params]
  (when-let [parent-type (:parent_type query-params)]
    {:parent-type parent-type
     :parent-collection-ids (split (:parent_collection_ids query-params) #",")
     :parent-id (:parent_id query-params)
     :complete-by (:complete_by query-params)
     :key (:parent_key query-params)}))
